var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-main',[(!_vm.tokenLoaded)?_c('loading-token'):(!_vm.tokenValid)?_c('invalid-token'):_c('select-collections',{attrs:{"token":_vm.token}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }